(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["xltd-uniform-builder"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('xltd-uniform-builder')) {
  customElements.define('xltd-uniform-builder', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.data = JSON.parse(this.querySelector('[data-products]').textContent);
      this.copy = JSON.parse(this.querySelector('[data-copy]').textContent);
      this.form = this.querySelector('[data-builder-form]');
      this.players = this.querySelector('[data-players]');
      this.money = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:this.dataset.currency || 'USD'});
      this.counter = 0;
      this.form.hidden = false;
      this.addPlayer();
      this.form.addEventListener('change', () => this.update());
      this.form.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button) return;
        if (button.hasAttribute('data-add-player')) this.addPlayer(true);
        if (button.hasAttribute('data-add-extra')) this.addExtra(button.closest('.xb-player'));
        if (button.hasAttribute('data-remove-extra')) { button.closest('.xb-extra').remove(); this.update(); }
        if (button.hasAttribute('data-remove-player') && this.players.children.length > 1) {
          button.closest('.xb-player').remove(); this.update(); this.querySelector('[data-add-player]').focus();
        }
      });
      this.form.addEventListener('submit', event => { event.preventDefault(); this.submit(); });
    }
    options(select, values) {
      values.forEach(value => { const option = document.createElement('option'); option.value = value; option.textContent = value; select.append(option); });
    }
    values(product, index) { return [...new Set(product.variants.map(variant => variant.options[index]))]; }
    field(row, name) { return row.querySelector('[data-field="' + name + '"]'); }
    addPlayer(focus = false) {
      if (this.players.children.length >= 50) return this.error(this.copy.limit);
      const row = this.querySelector('[data-player-template]').content.firstElementChild.cloneNode(true);
      row.dataset.player = String(++this.counter);
      row.querySelector('legend').textContent = this.copy.player + ' ' + this.counter;
      ['jersey', 'pants', 'size'].forEach((name,index) => this.options(this.field(row,name), this.values(this.data.set,index)));
      this.options(this.field(row,'pantsSize'), this.values(this.data.set,2));
      if (this.players.lastElementChild) ['jersey','pants','size','pantsSize'].forEach(name => { this.field(row,name).value = this.field(this.players.lastElementChild,name).value; });
      if (!this.data.extras?.variants?.length) row.querySelector('[data-add-extra]').hidden = true;
      this.players.append(row); this.update();
      if (focus) this.field(row,'name').focus();
    }
    addExtra(row) {
      if (this.querySelectorAll('.xb-extra').length >= 50) return this.error(this.copy.limit);
      const extra = this.querySelector('[data-extra-template]').content.firstElementChild.cloneNode(true);
      extra.querySelector('legend').textContent = this.copy.extra;
      this.options(this.field(extra,'piece'),this.values(this.data.extras,0));
      this.options(this.field(extra,'extraSize'),this.values(this.data.extras,1));
      this.field(extra,'extraSize').value = this.field(row,'size').value;
      row.querySelector('[data-extras]').append(extra); this.update(); this.field(extra,'piece').focus();
    }
    selected(product, options) { return product.variants.find(variant => variant.options.every((value,index) => value === options[index])); }
    lines() {
      const lines = [];
      const team = this.form.elements.team.value.trim();
      const notes = this.form.elements.notes.value.trim();
      for (const row of this.players.children) {
        const base = this.selected(this.data.set, ['jersey','pants','size'].map(name => this.field(row,name).value));
        const properties = {'Team name':team, 'Name on back':this.field(row,'name').value.trim(), 'Player number':this.field(row,'number').value.trim(), 'Pants size':this.field(row,'pantsSize').value, 'Customization instructions':notes, 'Roster player':row.dataset.player};
        lines.push({variant:base,properties});
        row.querySelectorAll('.xb-extra').forEach(extra => {
          const variant = this.selected(this.data.extras,['piece','extraSize'].map(name => this.field(extra,name).value));
          const extraProperties = {...properties};
          delete extraProperties['Pants size'];
          extraProperties['Matching design'] = this.data.set.title;
          lines.push({variant,properties:extraProperties});
        });
      }
      return lines;
    }
    update() {
      const lines = this.lines();
      this.querySelector('[data-total]').textContent = this.money.format(lines.reduce((sum,line) => sum + (line.variant?.price || 0),0)/100);
      this.players.querySelectorAll('[data-remove-player]').forEach(button => { button.hidden = this.players.children.length === 1; });
      this.querySelector('[data-add-player]').disabled = this.players.children.length >= 50;
      this.querySelector('[data-error]').hidden = true;
      this.form.querySelector('[type="submit"]').disabled = lines.some(line => !line.variant?.available);
      if (lines.some(line => !line.variant?.available)) this.error(this.copy.unavailable);
    }
    error(message) { const error = this.querySelector('[data-error]'); error.textContent = message; error.hidden = false; }
    async submit() {
      if (this.busy || !this.form.reportValidity()) return;
      const lines = this.lines();
      if (lines.some(line => !line.variant?.available)) return this.error(this.copy.unavailable);
      this.busy = true;
      const button = this.form.querySelector('[type="submit"]'); button.disabled = true; button.textContent = this.copy.adding;
      try {
        const response = await fetch(this.dataset.add, {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:lines.map(line => ({id:line.variant.id,quantity:1,properties:Object.fromEntries(Object.entries(line.properties).filter(([,value]) => value))}))})});
        const result = await response.json();
        if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : this.copy.error);
        window.location.assign(this.dataset.cart);
      } catch (error) {
        this.error(this.copy.error); this.querySelector('[data-error]').focus();
        this.busy = false; button.disabled = false; button.textContent = this.copy.add;
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
